<script>
	import { afterUpdate,onMount } from 'svelte';
	import { interventions, dataset, capacity, regionLabel, incomeLabel, capacityColor} from '../stores.js';
	
	export let active;
	
	import Template from '../components/Template.svelte';
	import CompareCard from '../components/CompareCard.svelte';
	
	$: countries = $dataset ? Object.values(Object.assign({}, $dataset.countries, $dataset.regions)) : [];
	$: regions = $dataset ? Object.keys($dataset.regions) : [];
	$: countriesPerRegion = {};
	$: countries.map(function(a) {
			if(a.available){
				return countriesPerRegion[a.region]?countriesPerRegion[a.region].push(a.country):countriesPerRegion[a.region]=[a.country];
			}
		});

	let comparedCountries = [];
	function filterCountry(event){
	    let v = this.value;
	    let cs = countries.filter(function(a) {
					if(a.country){
						return a.country==v?a:null;
					}
					else{
						return regionLabel(a.region)==v?a:null;
					}
				 });
	    if(cs){
	    	comparedCountries.push(cs[0]);
	    	comparedCountries = comparedCountries;
	    	this.value = "";
	    }
	}
	function remove(i){
    	comparedCountries.splice(i,1);
    	comparedCountries = comparedCountries;
	}
	onMount(async () => {
		document.querySelector('.search input').focus();
	});
</script>
<Template active={active}>
	<article class="compare">
		{#each interventions as int}
	    <input type="checkbox" name="intervention" id="intervention-{int.id}">
	    {/each}
	    
	    <div class="container-fluid wrap big-card">
	        <div class="row">
	            <div class="col-xs-4 col-md-3">
	                <!-- Guide Box -->
	                <section class="compare-guide">
	                    <header class="compare-header">
	                        <h2 class="title">Country, areas or regions <strong>capacities</strong></h2>
	                    </header>
						{#each interventions as int}
	                    <div class="compare-intervention" data-intervention="{int.id}">
	                        <div class="main">
	                            <div class="letter score-{int.code.toLowerCase()}"></div>
	                            <p>{@html int.title}</p>
	                            <label for="intervention-{int.id}" class="btn-plus"></label>
	                        </div>
	                        <ul class="elements">
	                        	{#each int.keyelements as kel}
	                            <li data-intervention="{kel.id}">{kel.title}</li>
	                            {/each}
	                        </ul>
	                    </div>
                        {/each}
	                    
	                </section>
	            </div>
	            <div class="col-xs-8 col-md-9">
	                <!-- Compare Box -->
	                <section class="compare-box">
						
						{#each comparedCountries as comp,i}
						<article class="card">
						    <button class="btn-close" on:click={()=>remove(i)}></button>
							<CompareCard country={comp} list={countriesPerRegion[comp.region]} />
						</article>
						{/each}
	                    
	                    {#if comparedCountries.length == 0}
	                    <div class="search">
	                        <input type="text" placeholder="Select a country, area or region" list="locations-list" on:change={filterCountry}>
	                        <span></span>
	                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.7 20.7">
	                            <circle cx="9.5" cy="9.5" r="8.5"/>
	                            <line x1="15.9" y1="15.9" x2="19.7" y2="19.7"/>
	                        </svg>
	                    </div>
	                    {/if}
	                    {#if comparedCountries.length < 3}
	                    <div class="search">
	                        <input type="text" placeholder="Select other country, area or region" list="locations-list" on:change={filterCountry}>
	                        <span></span>
	                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.7 20.7">
	                            <circle cx="9.5" cy="9.5" r="8.5"/>
	                            <line x1="15.9" y1="15.9" x2="19.7" y2="19.7"/>
	                        </svg>
	                    </div>
	                    {/if}
	                </section>
	            </div>
	        </div>
	    </div>
	</article>
	<aside class="graphism half compare-graphism-left"></aside>
	<aside class="graphism half compare-graphism-right"></aside>
</Template>